import { render } from "./WidgetContainer.vue?vue&type=template&id=8123f4c6&scoped=true"
import script from "./WidgetContainer.vue?vue&type=script&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&lang=js"

import "./WidgetContainer.vue?vue&type=style&index=0&id=8123f4c6&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8123f4c6"]])

export default __exports__